import
{
    NgModule
}
from '@angular/core';

import
{
    FormsModule
}
from '@angular/forms';

import
{
    BrowserAnimationsModule
}
from '@angular/platform-browser/animations';

import
{
    CommonModule
}
from '@angular/common';

import
{
    RouterModule
}
from '@angular/router';

import
{
    FaqComponent
}
from './faq/faq.component';

@NgModule(
{
    declarations: [
        FaqComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [
        FaqComponent
    ]
})
export class PagesModule
{}